var D = /* @__PURE__ */ ((L) => (L.DETAILED = "DETAILED", L.ALL = "ALL", L.MIN = "MIN", L))(D || {});
export {
  D as ApiProjections
};
//# sourceMappingURL=myshopConstantsEnum.js.map
